export default __webpack_public_path__ + "static/media/join-embedded@3x.55c14be3.jpg";